import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

export const StyledCrmEnrichmentJobIndustryMappingWarning = styled(Flex)`
    flex-shrink: 0;
    align-items: center;
`;
